"use client";

import React from "react";
import { ChevronDown, House } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SolucoesParaAmbientesCriticos() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  return <section id="soluções-para-ambientes-críticos" className="dark bg-background text-foreground relative w-full h-[70vh] min-h-[600px] flex flex-col overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-primary-900 via-primary-800/80 to-background">
        {}
        <div className="absolute inset-0 opacity-20">
          {}
          <div className="absolute left-[20%] top-1/2 -translate-y-1/2 w-16 h-96 bg-gradient-to-b from-primary-700 to-primary-900 rounded-sm border border-primary-400/20">
            <div className="absolute top-12 left-2 right-2 h-1 bg-primary-400 animate-pulse" style={{
            animationDelay: '0s'
          }}></div>
            <div className="absolute top-20 left-2 right-2 h-1 bg-primary-400 animate-pulse" style={{
            animationDelay: '0.5s'
          }}></div>
            <div className="absolute top-28 left-2 right-2 h-1 bg-primary-300 animate-pulse" style={{
            animationDelay: '1s'
          }}></div>
            <div className="absolute top-36 left-2 w-2 h-2 rounded-full bg-primary-500 animate-pulse"></div>
          </div>
          
          {}
          <div className="absolute right-[20%] top-1/2 -translate-y-1/2 w-16 h-96 bg-gradient-to-b from-primary-700 to-primary-900 rounded-sm border border-primary-400/20">
            <div className="absolute top-12 left-2 right-2 h-1 bg-primary-400 animate-pulse" style={{
            animationDelay: '0.3s'
          }}></div>
            <div className="absolute top-20 left-2 right-2 h-1 bg-primary-400 animate-pulse" style={{
            animationDelay: '0.8s'
          }}></div>
            <div className="absolute top-28 left-2 right-2 h-1 bg-primary-300 animate-pulse" style={{
            animationDelay: '1.3s'
          }}></div>
            <div className="absolute top-36 left-2 w-2 h-2 rounded-full bg-primary-500 animate-pulse"></div>
          </div>
        </div>

        {}
        <div className="absolute inset-0">
          {[...Array(30)].map((_, i) => <div key={i} data-index={i} className="absolute w-1 h-1 bg-primary-400/30 rounded-full animate-pulse" style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 3}s`,
          animationDuration: `${2 + Math.random() * 3}s`
        }} />)}
        </div>

        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent pointer-events-none" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_120%)] pointer-events-none" />
        
        {}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: `linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)`,
        backgroundSize: '40px 40px'
      }} />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 h-full flex flex-col justify-center items-center text-center">
        <div ref={textRef} className={`transition-all duration-1000 transform ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="flex justify-center mb-6">
            <Breadcrumb>
              <BreadcrumbList className="text-muted-foreground/80">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/HomePage" className="flex items-center gap-1 hover:text-primary transition-colors">
                      <House className="h-3 w-3" />
                      House
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-foreground font-medium">
                    Soluções
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-white drop-shadow-lg">
            Soluções de Engenharia <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-secondary-300">
              sob Medida
            </span>
          </h1>

          {}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 leading-relaxed">
            Projetos, equipamentos e serviços com confiabilidade para ambientes médico-hospitalares, 
            salas limpas, telecom e processos industriais.
          </p>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce">
        <div className="p-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm text-white/70">
          <ChevronDown className="w-6 h-6" />
        </div>
      </div>
    </section>;
}